import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import { Colors } from '../theme'
import Tooltip from './Tooltip'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'

class RBNumericTextBox extends Component {
  constructor () {
    super()
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.state = {
      formattedValue: '',
      value: '',
      error: ''
    }

    // save a copy
    this.baseState = this.state
  }

  resetState () {
    const self = this
    this.setState({ ...self.baseState })
  }

  handleBlur (textBoxValue) {
    if (this.props.onBlur) {
      this.props.onBlur(textBoxValue)
    }
  }

  handleChange (values) {
    const { formattedValue, value } = values
    this.setState({
      error: '',
      formattedValue,
      value
    }, () => this.props.onValueChange({ [this.props.id]: value }))
  }

  _renderToolTip () {
    const { tooltip } = this.props
    if (tooltip) {
      return (
        <Tooltip enterTouchDelay={0} leaveTouchDelay={3000} title={tooltip} placement="right-end">
          <IconButton >
            <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
          </IconButton>
        </Tooltip>
      )
    } else return null
  }

  render () {
    const { textLabel, maxValue, allowEmptyFormatting, ...props } = this.props
    const allowEmpty = (typeof allowEmptyFormatting === 'boolean') ? allowEmptyFormatting : true
    return (
      <FormControl fullWidth={props.fullWidth}>
        <InputLabel
          htmlFor="component-simple"
          shrink={props.floatingLabelFixed}
          error={!!props.error}
          style={{
            color: Colors.Palette.primaryTextColor
            // fontSize: props.floatingLabelFixed ? '1.2rem' : '0.85rem'
          }}
        >{textLabel}{this._renderToolTip()}</InputLabel>
        <NumberFormat
          // {...props}
          id={props.id}
          type={props.type}
          format={props.format}
          allowEmptyFormatting={allowEmpty}
          customInput={Input}
          fullWidth={props.fullWidth}
          value={this.state.formattedValue || this.props.value}
          onBlur={() => this.handleBlur(this.state.value)}
          onValueChange={(values) => this.handleChange(values)}
          error={!!props.error}
        />
        <FormHelperText id="component-error-text" error={!!props.error}>{props.error}</FormHelperText>
      </FormControl>
    )
  }
}

export default RBNumericTextBox



// WEBPACK FOOTER //
// ./src/controls/RBNumericTextBox.js